module.exports = __webpack_public_path__ + "cancellara-dist/img/konica-minolta.352826ff.png";